import request from "../utils/request";

//获取时区list
export function getTimeZoneList(data) {
    return request({
        url: `/customers/optionsInfo`,
        method: 'get',
        data
    });
}

//获取用户GoodsFields
export function getCustGoodsFields(data, customerCode) {
    return request({
        url: `/workbench/desktop/goodsField/${customerCode}`,
        method: 'get',
        data,
    });
}

//获取软件信息
export function aboutGetVersion(data) {
    return request({
        url: `/workbench/version`,
        method: 'get',
        data
    });
}

//获取用户功能开关配置
export function getCustFunConfig(data, customerCode) {
    return request({
        url: `/hiddenConfigs/${customerCode}/query`,
        method: 'get',
        data,
    });
}

//获取门店配置
export function getStoreConfig(data, customerCode, storeCode) {
    return request({
        url: `/storeconfig/${customerCode}/${storeCode}`,
        method: 'get',
        data,
    });
}

//获取license信息
export function getLicenseInfo(data) {
    return request({
        url: `/license/info`,
        method: 'get',
        data
    });
}

//上传license文件
export function importLicense(data) {
    return request({
        url: `/license/import`,
        method: 'post',
        data
    });
}


//获取系统配置
export function getSecureConfigApi(data) {
    return request({
        url: `/secure/config`,
        method: 'get',
        data
    });
}

//获取验证码图片
export function getCaptchaImgApi(data) {
    return request({
        url: `/captcha`,
        method: 'get',
        data
    });
}

//获取验证结果
export function getCaptchaResultApi(data) {
    return request({
        url: `/captcha/verify`,
        method: 'post',
        data
    });
}

/**
 * 
 * @param {
 *  containsAllNode  boolean  ”全部“节点
 *  withStore  boolean  门店节点
 *  containsDisableStore boolean  禁用门店 
 * } data 
 * @param { string } customerCode 
 * @returns 
 */
//获取用户管理组织结构
export function getUserOrgTreeApi(data, customerCode) {
    return request({
        url: `/organization/${customerCode}/tree`,
        method: 'get',
        data
    });
}

/**
 * 获取插件信息
 * @returns {
 *  Array <{
 *      code: String  // 权限码
 *      plugin: String // 名称
 *      relams: Array<String> // 显示视角
 *      type: String // 预留字段
 *      rawnName: String // 固定显示名称
 *      url: String  //跳转地址
 *      icon: String // 菜单icon name
 *      customerCode: Array //是否指定客户显示，无该字段按显示处理
 * }>
 * } 
 */
export function getPluginInfoApi() {
    return request({
        url: '/plugin/config',
        method: 'get'
    });
}

/**
 * 设置插件信息
 * @param {
 *  Array <{
 *      code: String  // 权限码
 *      plugin: String // 名称
 *      relams: Array<String> // 显示视角
 *      type: String // 预留字段
 *      rawnName: String // 固定显示名称
 *      url: String  //跳转地址
 *      icon: String // 菜单icon name
 *      customerCode: Array //是否指定客户显示，无该字段按显示处理
 * }>
 * } data 
 * @returns 
 */
export function editPluginInfoApi(data) {
    return request({
        url: '/plugin/config',
        method: 'put',
        data
    });
}

/**
 * get common translate
 * @param {
 *  language: List<string>,
 *  module: String,
 * } data 
 * @returns 
 */
export function getSystemTranslateApi(data) {
    return request({
        url: `/fieldmapping`,
        method: 'get',
        data
    });
}

/**
 * get user center info
 * @returns 
 */
export function getUserCenterInfoApi() {
    return request({
        url: `/realms/normal/users/info`,
        method: 'get',
    });
}

/**
 * verfiy pass
 * @param { Object} data 
 * @param { String} data.data 
 * @returns 
 */
export function verfiyPassApi(data) {
    return request({
        url: `/realms/normal/users/validatePwd`,
        method: 'post',
        data,
    });
}

/**
 * 
 * @param { Object } data 
 * @param { String } data.customerCode
 * @param { String } data.type
 * @param { String } data.storeCode
 * @returns 
 */
export function getExportConfigApi(data) {
    return request({
        url: `/addons/common/exportConfig`,
        method: 'get',
        data,
    });
}
/**
 * jump to plugin
 * @param { String } code 
 * @returns 
 */
export function toPluginUrlApi(code) {
    return request({
        url: `/plugin/redirect/${code}`,
        method: 'get',
    });
}

/**
 * get sessionid
 * @returns 
 */
export function getSessIdApi() {
    return request({
        url: `/binding/redirect/id`,
        method: 'get',
    });
}
